import React, { Component } from "react";
import Chart from "chart.js";
// import classes from "./LineGraph.module.css";
import moment from "moment";
export default class LineGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusData: props.statusData,
    };
  }
  inQueue = () => {
    var inQueueData = 0;
    const inQueueArray = this.state.statusData.filter(
      (data) => data.isEntryScan === false && data.isExited === false
    );
    for (var i = 0; i < inQueueArray.length; i++) {
      inQueueData = inQueueData + inQueueArray[i].covisitors + 1;
    }
    return inQueueData;
  };
  entered = () => {
    var enteredData = 0;
    const enteredArray = this.state.statusData.filter(
      (data) => data.isEntryScan === true && data.isExited === false
    );
    for (var i = 0; i < enteredArray.length; i++) {
      enteredData = enteredData + enteredArray[i].covisitors + 1;
    }
    return enteredData;
  };
  late = () => {
    var lateData = 0;
    // const entryScanFiltered = this.state.statusData.filter(
    //   (data) => data.isEntryScan === false
    // );

    for (var j = 0; j < this.state.statusData.length; j++) {
      if (this.state.statusData[j].entryTime) {
        if (
          moment(this.state.statusData[j].timeAlloted, "h:mm a").isBefore(
            moment(this.state.statusData[j].entryTime, "h:mm a")
          )
        ) {
          lateData = lateData + this.state.statusData[j].covisitors + 1;
        }
      } else if (
        moment(this.state.statusData[j].timeAlloted, "h:mm a").isBefore(
          moment()
        )
      ) {
        lateData = lateData + this.state.statusData[j].covisitors + 1;
      }
    }
    return lateData;
  };
  autoExited = () => {
    var autoExit = 0;
    const autoExitedFiltered = this.state.statusData.filter(
      (data) => data.isEntryScan === false && data.isExited === true
    );

    for (var j = 0; j < autoExitedFiltered.length; j++) {
      autoExit = autoExit + autoExitedFiltered[j].covisitors + 1;
    }
    return autoExit;
  };
  exited = () => {
    var exitCount = 0;
    const exitedFiltered = this.state.statusData.filter(
      (data) => data.isExited === true
    );

    for (var j = 0; j < exitedFiltered.length; j++) {
      exitCount = exitCount + exitedFiltered[j].covisitors + 1;
    }
    return exitCount;
  };

  chartRef = React.createRef();

  componentDidMount() {
    const myChartRef = this.chartRef.current.getContext("2d");

    new Chart(myChartRef, {
      type: "horizontalBar",
      data: {
        datasets: [
          {
            label: `In Queue ${this.inQueue()}`,
            backgroundColor: "#41FFAF",
            borderColor: "#20829A",
            borderWidth: 1,
            //stack: 1,
            // hoverBackgroundColor: "rgba(255,99,132,0.4)",
            // hoverBorderColor: "rgba(255,99,132,1)",
            data: [this.inQueue()],
          },
          {
            label: `Entered ${this.entered()}`,
            backgroundColor: "#E7FC2B",
            borderColor: "##8C9467",
            borderWidth: 1,
            //stack: 1,
            // hoverBackgroundColor: "rgba(255,99,132,0.4)",
            // hoverBorderColor: "rgba(255,99,132,1)",
            data: [this.entered()],
          },

          {
            label: `Late ${this.late()}`,
            backgroundColor: "#A096FC",
            borderColor: "#3865A0",
            borderWidth: 1,
            //stack: 1,
            // hoverBackgroundColor: "rgba(255,99,132,0.4)",
            // hoverBorderColor: "rgba(255,99,132,1)",
            data: [this.late()],
          },
          {
            label: `Auto Exited ${this.autoExited()}`,
            backgroundColor: "#FFB18C",
            borderColor: "#8B486E",
            borderWidth: 1,
            //stack: 1,
            // hoverBackgroundColor: "rgba(255,99,132,0.4)",
            // hoverBorderColor: "rgba(255,99,132,1)",
            data: [this.autoExited()],
          },
          {
            label: `Exited ${this.exited()}`,
            backgroundColor: "#41FFAF",
            borderColor: "#20829A",
            borderWidth: 1,
            //stack: 1,
            // hoverBackgroundColor: "rgba(255,99,132,0.4)",
            // hoverBorderColor: "rgba(255,99,132,1)",
            data: [this.exited()],
          },
        ],
      },
      options: {
        //Customize chart options
        // responsive: true,
        tooltips: false,
        // elements:{
        //   line:{borderColor:"yellow"}
        // },
        legend: {
          display: true,
          position: "left",
        },
      },
    });
  }
  render() {
    return (
      <div style={{ marginTop: "1vw", width: "30vw" }}>
        <canvas id="myChart" ref={this.chartRef} />
      </div>
    );
  }
}
